import { render, staticRenderFns } from "./recordheader.vue?vue&type=template&id=3c684e48&scoped=true&lang=html"
import script from "./recordheader.vue?vue&type=script&lang=js"
export * from "./recordheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c684e48",
  null
  
)

export default component.exports